import React from 'react';
import useAdminStore from '../../stores/adminStore';

const TestAdminStore = () => {
  const { 
    subscribers,
    addSubscriber,
    setSubscribers,
    statistics,
    updateStatistics,
    isLoading,
    error 
  } = useAdminStore();

  const handleAddSubscriber = () => {
    const newSubscriber = {
      id: Date.now(),
      name: `Abonné ${subscribers.length + 1}`,
      status: 'active',
      subscriptionDate: new Date().toISOString()
    };
    addSubscriber(newSubscriber);
  };

  const handleClearSubscribers = () => {
    setSubscribers([]);
  };

  return (
    <div className="p-4">
      <h2 className="text-xl font-bold mb-4">Test Store Admin</h2>
      
      <div className="space-y-4">
        <div className="flex gap-2">
          <button 
            onClick={handleAddSubscriber}
            className="bg-blue-500 text-white px-4 py-2 rounded"
          >
            Ajouter un abonné
          </button>
          <button 
            onClick={handleClearSubscribers}
            className="bg-red-500 text-white px-4 py-2 rounded"
          >
            Effacer les abonnés
          </button>
          <button 
            onClick={updateStatistics}
            className="bg-green-500 text-white px-4 py-2 rounded"
          >
            Mettre à jour les stats
          </button>
        </div>

        {isLoading && <p>Chargement...</p>}
        {error && <p className="text-red-500">{error}</p>}

        <div className="mt-4">
          <h3 className="font-bold mb-2">Statistiques :</h3>
          <div className="grid grid-cols-2 gap-4 mb-4">
            <div className="p-2 bg-gray-100 rounded">
              <p>Total abonnés : {statistics.totalSubscribers || 0}</p>
              <p>Abonnés actifs : {statistics.activeSubscribers || 0}</p>
            </div>
          </div>

          <h3 className="font-bold mb-2">Liste des abonnés :</h3>
          <ul className="space-y-2">
            {subscribers.map(subscriber => (
              <li key={subscriber.id} className="p-2 bg-gray-100 rounded">
                {subscriber.name} - {subscriber.status}
              </li>
            ))}
          </ul>
        </div>
      </div>
    </div>
  );
};

export default TestAdminStore; 